import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const certifications = [
    {
      id: 1,
      name: 'Uganda Communications Commission',
      description: 'Licensed ICT Service Provider',
      icon: 'Shield',
      verified: true
    },
    {
      id: 2,
      name: 'ISO 27001 Certified',
      description: 'Information Security Management',
      icon: 'Lock',
      verified: true
    },
    {
      id: 3,
      name: 'Uganda Registration Services Bureau',
      description: 'Registered Company #12345678',
      icon: 'Building',
      verified: true
    },
    {
      id: 4,
      name: 'SSL Secured',
      description: '256-bit Encryption',
      icon: 'ShieldCheck',
      verified: true
    }
  ];

  const stats = [
    { label: 'Trusted by', value: '500+', subtitle: 'Businesses' },
    { label: 'Years of', value: '10+', subtitle: 'Experience' },
    { label: 'Projects', value: '1000+', subtitle: 'Completed' },
    { label: 'Support', value: '24/7', subtitle: 'Available' }
  ];

  return (
    <div className="space-y-8">
      {/* Security Badges */}
      <div className="bg-card rounded-lg p-6 border border-border shadow-subtle">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="ShieldCheck" size={20} className="text-success" />
          <h3 className="text-lg font-semibold text-foreground">Secure & Trusted</h3>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {certifications?.map((cert) => (
            <div key={cert?.id} className="flex items-start space-x-3 p-3 bg-muted/50 rounded-lg">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
                  <Icon name={cert?.icon} size={16} className="text-success" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{cert?.name}</p>
                <p className="text-xs text-muted-foreground">{cert?.description}</p>
              </div>
              {cert?.verified && (
                <Icon name="CheckCircle" size={16} className="text-success" />
              )}
            </div>
          ))}
        </div>
      </div>
      {/* Company Stats */}
      <div className="bg-card rounded-lg p-6 border border-border shadow-subtle">
        <h3 className="text-lg font-semibold text-foreground mb-4">Why Choose TechTribes?</h3>
        
        <div className="grid grid-cols-2 gap-4 mb-6">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl font-bold text-primary">{stat?.value}</div>
              <div className="text-xs text-muted-foreground">{stat?.label}</div>
              <div className="text-xs text-muted-foreground">{stat?.subtitle}</div>
            </div>
          ))}
        </div>

        <div className="space-y-3 text-sm text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="MapPin" size={14} className="text-primary" />
            <span>Headquartered in Kampala, Uganda</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Award" size={14} className="text-primary" />
            <span>Leading ICT solutions provider in East Africa</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={14} className="text-primary" />
            <span>Serving government, SMEs, and enterprises</span>
          </div>
        </div>
      </div>
      {/* Contact Information */}
      <div className="bg-card rounded-lg p-6 border border-border shadow-subtle">
        <h3 className="text-lg font-semibold text-foreground mb-4">Need Help?</h3>
        
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <Icon name="Phone" size={16} className="text-primary" />
            <div>
              <p className="text-sm font-medium text-foreground">+256 700 123 456</p>
              <p className="text-xs text-muted-foreground">24/7 Support Hotline</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Icon name="Mail" size={16} className="text-primary" />
            <div>
              <p className="text-sm font-medium text-foreground">support@techtribes.ug</p>
              <p className="text-xs text-muted-foreground">Email Support</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Icon name="MessageCircle" size={16} className="text-primary" />
            <div>
              <p className="text-sm font-medium text-foreground">Live Chat Available</p>
              <p className="text-xs text-muted-foreground">Mon-Fri, 8AM-6PM EAT</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;